import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import { themeGet, Spinner } from '@primer/react';
import styled from 'styled-components';

var StatusLabel = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n  display: inline-flex;\n  align-items: center;\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: 16px;\n  text-align: center;\n  border-radius: ", ";\n  gap: ", ";\n  height: ", ";\n  padding: ", ";\n  text-transform: capitalize;\n  width: max-content;\n"], ["\n  background-color: ", ";\n  color: ", ";\n  display: inline-flex;\n  align-items: center;\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: 16px;\n  text-align: center;\n  border-radius: ", ";\n  gap: ", ";\n  height: ", ";\n  padding: ", ";\n  text-transform: capitalize;\n  width: max-content;\n"])), function (_a) {
  var backgroundColorToUse = _a.backgroundColorToUse;
  return backgroundColorToUse;
}, function (_a) {
  var colorToUse = _a.colorToUse;
  return colorToUse;
}, themeGet("fontSizes.1"), themeGet("fontWeights.bold"), function (_a) {
  var showStatusText = _a.showStatusText;
  return showStatusText ? "100px" : "50%";
}, themeGet("space.1"), function (_a) {
  var showStatusText = _a.showStatusText,
    height = _a.height;
  return showStatusText ? "24px" : "".concat(height + 4, "px");
}, function (_a) {
  var padding = _a.padding;
  return padding;
});
/**
 * Status label for test status
 * This card will be used in Automation (Web + App)
 * @param {string} iconSrc The icon to be used for rendering test status.
 * @param {string} status The status of the test.
 */
var LTTestStatusLabel = function LTTestStatusLabel(_a) {
  var _b = _a.iconSrc,
    iconSrc = _b === void 0 ? "" : _b,
    _c = _a.status,
    status = _c === void 0 ? "" : _c,
    _d = _a.showStatusText,
    showStatusText = _d === void 0 ? true : _d,
    _e = _a.width,
    width = _e === void 0 ? "14" : _e,
    _f = _a.height,
    height = _f === void 0 ? "14" : _f;
  var backgroundColorToUse = "";
  var colorToUse = "#fff";
  switch (status) {
    case "passed":
    case "active":
      backgroundColorToUse = "#176f2c";
      break;
    case "completed":
      backgroundColorToUse = "#666666";
      break;
    case "failed":
      backgroundColorToUse = "#CF222E";
      break;
    case "error":
      backgroundColorToUse = "#CF222E";
      break;
    case "lambda error":
      backgroundColorToUse = "#087493";
      break;
    case "ignored":
      backgroundColorToUse = "#666666";
      // colorToUse = "#101010";
      break;
    case "aborted":
      backgroundColorToUse = "#C24E00";
      break;
    case "skipped":
      backgroundColorToUse = "#666666";
      // colorToUse = "#101010";
      break;
    case "stopped":
      backgroundColorToUse = "#A40E26";
      break;
    case "cancelled":
      backgroundColorToUse = "#C24E00";
      break;
    case "running":
    case "in-progress":
      backgroundColorToUse = "#0969DA";
      break;
    case "queued":
      backgroundColorToUse = "#8250DF";
      break;
    case "queue_timeout":
      backgroundColorToUse = "#8250DF";
      break;
    case "idle_timeout":
    case "pqueued":
      backgroundColorToUse = "#9A6700";
      break;
    case "initiated":
      backgroundColorToUse = "#033D8B";
      break;
    case "unknown":
      backgroundColorToUse = "#666666";
      break;
    default:
      {
        backgroundColorToUse = "#F7F7F7";
      }
  }
  var calculatePadding = function calculatePadding(showStatusText) {
    if (showStatusText) {
      return "2px 8px";
    } else {
      return "2px";
    }
  };
  return /*#__PURE__*/React.createElement(StatusLabel, {
    className: "testStatus",
    backgroundColorToUse: backgroundColorToUse,
    colorToUse: colorToUse,
    showStatusText: showStatusText,
    height: height,
    padding: calculatePadding(showStatusText)
  }, iconSrc ? /*#__PURE__*/React.createElement("img", {
    alt: "test-status",
    src: iconSrc,
    width: width,
    height: height
  }) : /*#__PURE__*/React.createElement(Spinner, {
    size: "small"
  }), showStatusText && status);
};
var templateObject_1;

export { LTTestStatusLabel as default };
